import { render, staticRenderFns } from "./Expend.vue?vue&type=template&id=63749a80&scoped=true"
import script from "./Expend.vue?vue&type=script&lang=js"
export * from "./Expend.vue?vue&type=script&lang=js"
import style0 from "./Expend.vue?vue&type=style&index=0&id=63749a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63749a80",
  null
  
)

export default component.exports